import { FooterWrapper, FooterWrapperFixed } from 'containers/styled';
import { useRouter } from 'next/router';
import React, { useRef } from 'react';

import { CommonsType } from 'types/commons';
import { BlogPostType } from 'types/blogPage';

import Footer from 'components/Footer';
import HeaderLogo from 'components/FilmPage/HeaderLogo';

import useDesktopMode from 'utils/hooks/useDesktopMode';
import theme from 'utils/theme';
import { v4 } from 'uuid';

import { Background, DescriptionWrapper, Content, Wrapper } from './styled';
import Post from './Post';

export type BlogProps = {
  background: { url: string };
  backgroundMobile: { url: string };
  content: Array<BlogPostType>;
  commons: CommonsType;
  heading: string;
};

const Blog = ({
  background,
  backgroundMobile,
  content,
  commons,
}: BlogProps): JSX.Element => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { isDesktopMode } = useDesktopMode();
  const router = useRouter();

  return (
    <Wrapper>
      <HeaderLogo onClick={() => router.push('/')} />
      {isDesktopMode && <Background src={background.url} />}
      {!isDesktopMode && <Background src={backgroundMobile.url} />}
      <Content>
        <DescriptionWrapper ref={contentRef}>
          {content.map(item => (
            <Post key={v4()} data={item} />
          ))}
          {!isDesktopMode && (
            <Footer
              line={true}
              sticky={false}
              color={theme.colors.primary.light}
              copy={commons.footer}
              jumpTarget={contentRef.current}
            />
          )}
        </DescriptionWrapper>
      </Content>
      {isDesktopMode && (
        <FooterWrapperFixed>
          <Footer
            line={false}
            sticky={true}
            color={theme.colors.primary.light}
            copy={commons.footer}
          />
        </FooterWrapperFixed>
      )}
    </Wrapper>
  );
};

export default Blog;
